export default __webpack_public_path__ + "static/media/earphone.fc1d8f89.png";